var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":"AIzaSyAGQeljdWK0A-z_4Hmj9eNrufJMh0mC8S4"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker,i){return _c('GoogleMapDropMarker',{key:marker.SK,attrs:{"label":(i + 1).toString(),"marker":marker,"google":google,"map":map}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }